<template>
  <div class="q-pa-md">
    <q-table
      title="Utilizadores"
      :rows="users"
      :columns="columns"
      row-key="id"
      :loading="loading"
      :pagination="{ rowsPerPage: 10 }"
    >
      <!-- Active Status Column -->
      <template v-slot:body-cell-active="props">
        <q-td :props="props">
          <q-badge :color="props.row.active ? 'positive' : 'negative'">
            {{ props.row.active ? 'Ativo' : 'Inativo' }}
          </q-badge>
        </q-td>
      </template>

      <!-- Role Column -->
      <template v-slot:body-cell-role="props">
        <q-td :props="props">
          <q-badge :color="props.row.role === 1 ? 'primary' : 'grey'">
            {{ props.row.role === 1 ? 'Admin' : 'Agente' }}
          </q-badge>
        </q-td>
      </template>

      <!-- Actions Column -->
      <template v-slot:body-cell-actions="props">
        <q-td :props="props">
          <q-btn
            flat
            round
            dense
            :color="props.row.active ? 'orange' : 'positive'"
            :icon="props.row.active ? 'block' : 'check_circle'"
            @click="toggleActive(props.row)"
          >
            <q-tooltip>
              {{ props.row.active ? 'Deactivate' : 'Activate' }}
            </q-tooltip>
          </q-btn>

          <q-btn
            flat
            round
            dense
            :color="props.row.role === 1 ? 'grey' : 'primary'"
            icon="admin_panel_settings"
            @click="toggleAdmin(props.row)"
          >
            <q-tooltip>
              {{ props.row.role === 1 ? 'Remove Admin' : 'Make Admin' }}
            </q-tooltip>
          </q-btn>

          <q-btn
            flat
            round
            dense
            color="negative"
            icon="delete"
            @click="confirmDelete(props.row)"
          >
            <q-tooltip>Delete User</q-tooltip>
          </q-btn>
        </q-td>
      </template>
    </q-table>

    <!-- Delete Confirmation Dialog -->
    <q-dialog v-model="deleteDialog">
      <q-card>
        <q-card-section>
          <div class="text-h6">Delete User</div>
        </q-card-section>

        <q-card-section>
          Are you sure you want to delete user <strong>{{ userToDelete?.name }}</strong>?
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" color="negative" @click="deleteUser" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
// import { useQuasar } from 'quasar';
import store from '@/vuex/store';
import Swal from 'sweetalert2';

export default {
  name: 'UsersList',

  setup() {
    // const $q = useQuasar();
    const deleteDialog = ref(false);
    const userToDelete = ref(null);

    const columns = [
      {
        name: 'id',
        label: 'ID',
        field: 'id',
        align: 'left',
        sortable: true
      },
      {
        name: 'name',
        label: 'Name',
        field: 'name',
        align: 'left',
        sortable: true
      },
      {
        name: 'email',
        label: 'Email',
        field: 'email',
        align: 'left',
        sortable: true
      },
      {
        name: 'phone',
        label: 'Phone',
        field: 'phone',
        align: 'left',
        format: (val) => val || 'N/A'
      },
      {
        name: 'active',
        label: 'Status',
        field: 'active',
        align: 'center',
        sortable: true
      },
      {
        name: 'role',
        label: 'Role',
        field: 'role',
        align: 'center',
        sortable: true
      },
      {
        name: 'created_at',
        label: 'Created At',
        field: 'created_at',
        align: 'left',
        sortable: true
      },
      {
        name: 'actions',
        label: 'Actions',
        field: 'actions',
        align: 'center'
      }
    ];

    const users = ref([]);
    const loading = ref(false);

    const toggleActive = (user) => {
      user.active = user.active ? 0 : 1;

      Swal.fire({
            title: "Tem certeza?",
            text: `Você está prestes a ${user.active ? 'ativar' : 'desativar'} este usuário.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Sim, ${user.active ? 'Ativar' : 'Desativar'}!`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await store.dispatch('admin/changeUserStatus' ,user)
                        Swal.fire({
                            title: `${user.active ? "Ativado!" : "Desativado!"}`,
                            text: "O status do usuário foi atualizado.",
                            icon: "success"
                        });
                    } catch (error) {
                        console.error("Error updating user status:", error);
                        Swal.fire({
                            title: "Error!",
                            text: "There was an error updating the user status.",
                            icon: "error"
                        });
                    }
                }
            });
    //   console.log(user)
    };

    const toggleAdmin = (user) => {
      user.role = user.role === 1 ? 0 : 1;
      Swal.fire({
            title: "Tem certeza?",
            text: `Você está prestes a tornar ${user.role ? 'Admin' : 'Agente'} este usuário.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Sim, tornar ${user.role ? 'Admin' : 'Agente'}!`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await store.dispatch('admin/changeUserAdmin' ,user)
                        Swal.fire({
                            title: `${user.active ? "Admin!" : "Agente!"}`,
                            text: "A permissão do usuário foi atualizada.",
                            icon: "success"
                        });
                    } catch (error) {
                        console.error("Error updating user status:", error);
                        Swal.fire({
                            title: "Error!",
                            text: "There was an error updating the user status.",
                            icon: "error"
                        });
                    }
                }
            });
    };

    const confirmDelete = (user) => {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Funcionalidade ainda não disponivel!",
         });
         console.log("Delete user:", user);
    //   userToDelete.value = user;
    //   deleteDialog.value = true;
    };

    const deleteUser = () => {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Funcionalidade ainda não disponivel!",
         });
    //   const index = users.value.findIndex(u => u.id === userToDelete.value.id);
    //   if (index > -1) {
    //     users.value.splice(index, 1);
    //     $q.notify({
    //       type: 'negative',
    //       message: 'User deleted successfully',
    //       position: 'top'
    //     });
    //   }
    //   deleteDialog.value = false;
    //   userToDelete.value = null;
    };

    const fetchUsers = async () => {
      loading.value = true;
      try {
        // Replace with your actual API endpoint
        const res = await store.dispatch('admin/getUsers');
        users.value = res;
        // users.value = store.state.admin.users;
        // console.log('Fetched users:', users.value);
      } catch (error) {
        
        console.error('Error fetching users:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchUsers();
    });

    return {
      columns,
      users,
      loading,
      deleteDialog,
      userToDelete,
      toggleActive,
      toggleAdmin,
      confirmDelete,
      deleteUser,
      fetchUsers
    };
  }
};
</script>

<style scoped>
.q-table {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
}
</style>